import React from 'react';
import { Button } from '../ui/button';
import { Apple, ArrowRight, Heart } from 'lucide-react';
import { toast } from 'sonner';

const CTA = () => {
  const handleAppStoreClick = () => {
    toast('Coming Soon', {
      description: 'The app will be available on the App Store shortly!',
    });
  };

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-500/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-br from-teal-500/10 to-cyan-500/10 rounded-full blur-3xl" />
      </div>

      {/* Grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:60px_60px]" />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-3xl mb-8 shadow-2xl shadow-teal-500/30">
          <Heart className="w-10 h-10 text-white" />
        </div>

        {/* Heading */}
        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Build a Stronger Future Through
          <br />
          <span className="bg-gradient-to-r from-teal-400 via-cyan-400 to-emerald-400 bg-clip-text text-transparent">
            Active Diabetes Care
          </span>
        </h2>

        {/* Description */}
        <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed">
          Download now and capture the moments that matter. Track, reflect, and organize your diabetes care all in one place.
        </p>

        {/* CTA Button */}
        <div className="flex justify-center">
          <Button 
            size="lg" 
            className="bg-white hover:bg-slate-100 text-slate-900 px-8 py-7 text-lg rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 group"
            onClick={handleAppStoreClick}
          >
            <Apple className="w-6 h-6 mr-3" />
            Download on App Store
            <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
